<template>
  <div class="in-mars-ape-sider">
    <el-menu
      class="insider-menu"
      background-color="#fff"
    >
      <li
        role="menuitem"
        aria-haspopup="true"
        class="el-submenu"
      >
        <div
          class="first-title"
        >
          <span>栏目</span>
        </div>
      </li>
      <li
        role="menuitem"
        aria-haspopup="true"
        v-for="(item, index) in menuList"
        :key="index"
      >
        <div class="el-submenu" v-if="item.isShow">
          <a @click="goTo(item.display_name, item.inSiderName, item.isActive, index)" :class=" item.isActive ? `no-active${index}` : `active${index}`">{{ item.display_name }}</a>
        </div>
      </li>
    </el-menu>
  </div>
</template>
<script>
export default {
  props: {
    category: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      menuList: [
        {
          display_name: "商户基本信息",
          icon: "",
          id: 0,
          isActive: true,
          isShow: true,
          inSiderName: 'basicInfo'
        },
        {
          display_name: "创建银行账户",
          icon: "",
          id: 1,
          isActive: false,
          isShow: true,
          inSiderName: 'bankAccount'
        },
        {
          display_name: "用户信息",
          icon: "",
          id: 2,
          isActive: false,
          isShow: true,
          inSiderName: 'userInfo'
        },
      ],
    };
  },
  methods: {
    goTo(display_name, inSiderName, isActive, index) {
      this.menuList.forEach((item, i)=> {
        if(index == i) {
          item.isActive = true
        }else {
          item.isActive = false
        }
      })
      this.$emit("goTo", display_name, inSiderName);
    },
  },
  async mounted() {
    this.menuList.forEach((item, index) => {
      if(this.category == 'channel' && index == 1) {
        item.isShow = false
      }
    })
  }
};
</script>

<style lang="stylus">
.in-mars-ape-sider{
  // width: 220px !important;
  min-width: 110px;
  transition: all 0.3s;
}
.in-mars-ape-sider{
  /* 导航内容 */
  .insider-menu {
    min-height: 1290px;
    width: auto !important;
    transition: all 0.3s;
    border: 1px solid #E5E5E5;
  }
  .insider-menu.el-menu {
    list-style: none;
    position: relative;
    margin: 0;
    padding-left: 0;
    background-color: #2c343f;
    border: 1px solid #E5E5E5 !important;
  }
  .el-submenu a {
    padding-left: 20px;
    text-decoration: none;
    display: block;
  }
  .el-submenu:hover {
    cursor: pointer
  }
  .el-submenu .active {
    color: #409eff
  }
  .el-submenu .no-active0,
  .el-submenu .no-active1,
  .el-submenu .no-active2,
   {
    background: #6598b5;
    color: #fff;
  }
  .first-title {
    // padding-left: 24px !important;
    // padding-right: 34px;
    line-height: 50px;
    height: 50px;
    color: #fff;
    background: #61A7CF;
    text-align: center;
  }
  .el-submenu {
    height: 50px;
    line-height: 50px;
  }
}
</style>